/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class AddNewSiteSuccess extends React.Component<*> {
  componentDidMount() {
    const { actionDrawerStore }: TypeProps = this.props;
    const parentForm: Object = this.props.parentForm;
    const model: Object = this.props.model;
    const childmodel: Object = this.props.childmodel;
    const resetModels: Array = this.props.resetModels;
    const resetFields: Array = this.props.resetFields;

    // Building
    const field: Object = parentForm.$('location.locationBuilding');
    const fieldExtra: Object = field.extra;

    field.set('value', actionDrawerStore.response.name);
    field.set('extra', { ...fieldExtra, selectID: actionDrawerStore.response.id });
    // IDs should be returned in success save of locations
    model.filterId =
      `/${parentForm.$('location.locationCompany').extra.selectID}` +
      `/${parentForm.$('location.countryId').value}` +
      `?parent_id=${parentForm.$('location.locationSite').extra.selectID}`;
    model.parentId = parentForm.$('location.locationSite').extra.selectID;
    model.selected = actionDrawerStore.response.id;
    model.search = '';
    model.loadData();

    // Reset Room
    const fieldModel: Object = parentForm.$('location.locationRoom');
    const fieldModelExtra: Object = fieldModel.extra;

    fieldModel.set('value', '');
    fieldModel.set('extra', { ...fieldModelExtra, selectID: '' });
    fieldModel.set('extra', { ...fieldModelExtra, parentId: '' });
    // childmodel.filterId = actionDrawerStore.response.id;
    // childmodel.parentId = actionDrawerStore.response.id;
    // childmodel.loadData();

    // Reset Systems
    const fieldSystem: Object = parentForm.$('location.locationSystem');
    const fieldSystemExtra: Object = fieldSystem.extra;

    fieldSystem.set('value', '');
    fieldSystem.set('extra', { ...fieldSystemExtra, selectID: '' });
    fieldSystem.set('extra', { ...fieldSystemExtra, parentId: '' });

    // Reset Models
    for (let i: * = 0; i < resetModels.length; i++) {
      resetModels[i].clear();
      resetModels[i].loadData();
    }

    // Reset Fields
    for (let i: * = 0; i < resetFields.length; i++) {
      resetFields[i].extra.selectID = '';
    }

    actionDrawerStore.closeActionDrawer();
  }

  render(): React.Element<*> {
    return 'success';
  }
}
